import { Button, Grid, makeStyles, Modal, Paper } from '@material-ui/core'
import { FC } from 'react'
import useTranslate from '../../../i18n/useTranslate'

interface ModalPDPAProps {
    onClose: () => void
    onAccept: () => void
    open: boolean
    consent: string
}
const ModalPDPA: FC<ModalPDPAProps> = ({ onClose, onAccept, open, consent }) => {
    const classes = useStyles()
    const translate = useTranslate()
    return (
        <Modal open={open}>
            <Grid container justify="center" className={classes.root}>
                <Grid item xs={12} md={11}>
                    <Paper className={classes.paper}>
                        <Grid container justify="center" spacing={2}>
                            <Grid item xs={12}>
                                <div
                                    style={{ padding: '24px' }}
                                    dangerouslySetInnerHTML={{
                                        __html: consent,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Button color="inherit" fullWidth size={'large'} variant="contained" onClick={onClose}>
                                    {translate.get('UM.PDPA.CLOSE')}
                                </Button>
                            </Grid>
                            <Grid item xs={2}>
                                <Button size={'large'} fullWidth variant="contained" color="primary" onClick={onAccept}>
                                    {translate.get('UM.PDPA.ACCEPT')}
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Modal>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        overflowY: 'scroll',
    },
    paper: {
        width: '100%',
        margin: '3rem 0px',
        padding: '2rem 0px',
        [theme.breakpoints.down('sm')]: {
            height: '100%',
            margin: '0px',
        },
    },
}))

export default ModalPDPA
